<template>
  <v-flex class="overlay" v-if="this.$store.state.loading">
    <v-card>
      <v-card-title>
        <v-layout column align-center>
          <v-flex>
            <orbit-spinner :animation-duration="1200" :size="100" color="#29d" />
          </v-flex>
          <v-flex>
            <h4 class="display-1 text-center">{{ $t(this.$store.state.message) }}</h4>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "rLoadingOverlay"
};
</script>

<style scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(39, 42, 43, 0.8);
  transition: opacity 200ms ease-in-out;
  border-radius: 4px;
}
</style>
